export const PowerSources = {
    0: 'AC Plugged',
    1: 'AC Unplugged',
    2: 'Battery',
    default: 'Unknown'
}